
import {post} from '@/utils/request';
import {erpserver,oaserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

//树
export async function getDeptTree(params) {
    return post(erpserver+'/wxuser/getDeptTree', params, true)
}
//用户列表
export async function getWxUserList(params) {
    return post(erpserver+'/wxuser/getWxUserList', params, true)
}
//新增内部用户
export async function getInnerUserList(params) {
    return post(erpserver+'/wxuser/getInnerUserList', params, true)
}
//保存新增内部用户
export async function addWxUser(params) {
    return post(erpserver+'/wxuser/addWxUser', params, true)
}
//用户详情
export async function getUserInfo(params) {
    return post(erpserver+'/wxuser/getWxUserInfo', params, true)
}
//更新用户详情
export async function updWxUser(params) {
    return post(erpserver+'/wxuser/updWxUser', params, true)
}
//更新用户详情
export async function voidWxUser(params) {
    return post(erpserver+'/wxuser/voidWxUser', params, true)
}
//app类型
export async function getAppList(params) {
    return post(erpserver+'/wxuser/getAppList', params, true)
}
//授权
export async function authWxApp(params) {
    return post(erpserver+'/wxuser/authWxApp', params, true)
}